import "./member.css";
import {FOBBetslip, canonicalFobPairOrder, isFobItemPlayable} from "../../features/betslip/fob.service";
import React, {useEffect, useRef, useState} from "react";
import {ApiService} from "../../lib/http.service";
import {env} from "../../constants/global.vars";
import {copyMemberNumber, CurrencyFormat, dateTimeFormat, mobileView, shareOnSocial} from "../../services/misc.functions";
import {getAvailableHippodromes, getBulletinCardId, getHippodromesMap, useBulletinCardId} from "../../features/bulletin/bulletin.store";
import {BettingTypeIds, BettingTypesMap} from "../../features/core/definitions";
import {FOB_TOP_N, fobTopNScore, normalizeTicketLegs, resolveTicketCards, rowHippodromeKeyword} from "./ticket-resolve";
import {GetStablemateIcon} from "../betting/components/betting-datatable";
import {useDailyRaces} from "../../features/bulletin/bulletin.store";
import {restoreMutualCoupon} from "../../features/betslip/mutual.service";
import {showClosedTicketModal, showReplayErrorModal} from "../betting/replay-error";
import _ from "lodash";
import {modalServiceSubject} from "../../services/modal.service";
import {NavigateFunction, useLocation, useNavigate} from "react-router-dom";
import paths from "../../paths";
import {auth} from "../../store/auth.store";
import Modal from "react-modal";
import {isMobile} from "../../App";
import shareIcon from "../../assets/feather/share-2.svg"
import iconInfo from "../../assets/feather/info.svg"

const tabs = [
    {value: "bekleyen-biletlerim", label: "Güncel", content: <TicketList status={null}/>},
    {value: "kazanan-biletlerim", label: "Kazanan", content: <TicketList status={2}/>},
    {value: "kaybeden-biletlerim", label: "Kaybeden", content: <TicketList status={3}/>},
    {value: "kayitli-biletlerim", label: "Kayıtlı", content: <TicketList status={6}/>},
    {value: "hazir-kuponlar", label: "Hazır Kuponlar", content: <TicketList status={7}/>},
];

export function showEstimatedWinInfoModal() {
    modalServiceSubject.next({
        case: "info",
        title: "Tahmini Kazanç Hakkında",
        innerHtml: true,
        content: `<p class="text-small text-center">Tahmini Kazanç, biletinizdeki oranlar üzerinden
                    hesaplanan yaklaşık tutardır. Biletinizdeki bahislerden birinin iptal olması ya da
                    oranların güncellenmesi durumunda ödenecek tutar değişebilir. Kesin kazanç tutarı,
                    resmî sonuçların ilanıyla biletiniz sonuçlandığında belli olur.</p>`,
        confirm: {
            cancel: {
                label: "Kapat",
            },
        },
    });
}

const CLOCK_ICON = '<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5938 8C13.5938 9.61616 12.9517 11.1661 11.8089 12.3089C10.6661 13.4517 9.11616 14.0938 7.5 14.0938C5.88384 14.0938 4.33387 13.4517 3.19107 12.3089C2.04827 11.1661 1.40625 9.61616 1.40625 8C1.40625 6.38384 2.04827 4.83387 3.19107 3.69107C4.33387 2.54827 5.88384 1.90625 7.5 1.90625C9.11616 1.90625 10.6661 2.54827 11.8089 3.69107C12.9517 4.83387 13.5938 6.38384 13.5938 8ZM0 8C0 9.98912 0.790176 11.8968 2.1967 13.3033C3.60322 14.7098 5.51088 15.5 7.5 15.5C9.48912 15.5 11.3968 14.7098 12.8033 13.3033C14.2098 11.8968 15 9.98912 15 8C15 6.01088 14.2098 4.10322 12.8033 2.6967C11.3968 1.29018 9.48912 0.5 7.5 0.5C5.51088 0.5 3.60322 1.29018 2.1967 2.6967C0.790176 4.10322 0 6.01088 0 8ZM6.79688 4.01562V8C6.79688 8.23438 6.91406 8.4541 7.11035 8.58594L9.92285 10.4609C10.2451 10.6777 10.6816 10.5898 10.8984 10.2646C11.1152 9.93945 11.0273 9.50586 10.7021 9.28906L8.20312 7.625V4.01562C8.20312 3.62598 7.88965 3.3125 7.5 3.3125C7.11035 3.3125 6.79688 3.62598 6.79688 4.01562Z" fill="#DA7E29"></path></svg>';
const CHECK_ICON = '<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 1.90625C9.11616 1.90625 10.6661 2.54827 11.8089 3.69107C12.9517 4.83387 13.5938 6.38384 13.5938 8C13.5938 9.61616 12.9517 11.1661 11.8089 12.3089C10.6661 13.4517 9.11616 14.0938 7.5 14.0938C5.88384 14.0938 4.33387 13.4517 3.19107 12.3089C2.04827 11.1661 1.40625 9.61616 1.40625 8C1.40625 6.38384 2.04827 4.83387 3.19107 3.69107C4.33387 2.54827 5.88384 1.90625 7.5 1.90625ZM7.5 15.5C9.48912 15.5 11.3968 14.7098 12.8033 13.3033C14.2098 11.8968 15 9.98912 15 8C15 6.01088 14.2098 4.10322 12.8033 2.6967C11.3968 1.29018 9.48912 0.5 7.5 0.5C5.51088 0.5 3.60322 1.29018 2.1967 2.6967C0.790176 4.10322 0 6.01088 0 8C0 9.98912 0.790176 11.8968 2.1967 13.3033C3.60322 14.7098 5.51088 15.5 7.5 15.5ZM10.8105 6.62305C11.0859 6.34766 11.0859 5.90234 10.8105 5.62988C10.5352 5.35742 10.0898 5.35449 9.81738 5.62988L6.56543 8.88184L5.18848 7.50488C4.91309 7.22949 4.46777 7.22949 4.19531 7.50488C3.92285 7.78027 3.91992 8.22559 4.19531 8.49805L6.07031 10.373C6.3457 10.6484 6.79102 10.6484 7.06348 10.373L10.8105 6.62305Z" fill="#008000"></path></svg>';
const CROSS_ICON = '<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 1.90625C9.11616 1.90625 10.6661 2.54827 11.8089 3.69107C12.9517 4.83387 13.5938 6.38384 13.5938 8C13.5938 9.61616 12.9517 11.1661 11.8089 12.3089C10.6661 13.4517 9.11616 14.0938 7.5 14.0938C5.88384 14.0938 4.33387 13.4517 3.19107 12.3089C2.04827 11.1661 1.40625 9.61616 1.40625 8C1.40625 6.38384 2.04827 4.83387 3.19107 3.69107C4.33387 2.54827 5.88384 1.90625 7.5 1.90625ZM7.5 15.5C9.48912 15.5 11.3968 14.7098 12.8033 13.3033C14.2098 11.8968 15 9.98912 15 8C15 6.01088 14.2098 4.10322 12.8033 2.6967C11.3968 1.29018 9.48912 0.5 7.5 0.5C5.51088 0.5 3.60322 1.29018 2.1967 2.6967C0.790176 4.10322 0 6.01088 0 8C0 9.98912 0.790176 11.8968 2.1967 13.3033C3.60322 14.7098 5.51088 15.5 7.5 15.5ZM5.12695 5.62695C4.85156 5.90234 4.85156 6.34766 5.12695 6.62012L6.50391 7.99707L5.12695 9.37402C4.85156 9.64941 4.85156 10.0947 5.12695 10.3672C5.40234 10.6396 5.84766 10.6426 6.12012 10.3672L7.49707 8.99023L8.87402 10.3672C9.14941 10.6426 9.59473 10.6426 9.86719 10.3672C10.1396 10.0918 10.1426 9.64648 9.86719 9.37402L8.49023 7.99707L9.86719 6.62012C10.1426 6.34473 10.1426 5.89941 9.86719 5.62695C9.5918 5.35449 9.14648 5.35156 8.87402 5.62695L7.49707 7.00391L6.12012 5.62695C5.84473 5.35156 5.39941 5.35156 5.12695 5.62695Z" fill="#EC4950"></path></svg>';

const statusMap: any = {
    0: {label: "MBS Cevabı Bekliyor", class: "rgb(218, 126, 41)", style: "linear-gradient(180deg, #666666 0%, #4D4D4D 100%)", icon: CLOCK_ICON},
    1: {label: "Devam Ediyor", class: "rgb(218, 126, 41)", style: "linear-gradient(180deg, #F79009 0%, #C56A09 100%)", icon: CLOCK_ICON},
    2: {label: "Kazandınız", class: "rgb(0, 128, 0)", style: "linear-gradient(180deg, #1DCA6C 0%, #128346 100%)", icon: CHECK_ICON},
    3: {label: "Kaybettiniz", class: "rgb(236, 73, 80)", style: "linear-gradient(180deg, #D83131 0%, #B52020 100%)", icon: CROSS_ICON},
    // İptal ve iptal bekleyen rozetler KAZANMA yeşilini kullanıyordu (status 2 ile aynı
    // gradient); iptal edilmiş bilet kazanmış gibi görünüyordu.
    4: {label: "İptal", class: "rgb(236, 73, 80)", style: "linear-gradient(180deg, #D83131 0%, #B52020 100%)", icon: CROSS_ICON},
    5: {label: "Oynanamadı / Hatalı", class: "text-bg-danger"},
    6: {label: "Kayıtlı Kupon", style: "linear-gradient(180deg, #31A0D8 0%, #2083B5 100%)", class: "text-bg-secondary"},
    7: {label: "Hazır Kupon", class: "text-bg-secondary"},
    8: {label: "MBS İptal Bekleniyor", class: "rgb(236, 73, 80)", style: "linear-gradient(180deg, #D83131 0%, #B52020 100%)", icon: CROSS_ICON},
}

const pendingStatusHint = (status: any): string | null => {
    if (Number(status) === 8) {
        return "İptal Beklemede statüsündeki biletiniz iptal edildi anlamına gelmez. İptal talebiniz iletildi, sonuçlanana kadar biletiniz geçerlidir. İptal onaylandığında bilet tutarı hesabınıza iade edilir.";
    }
    if (Number(status) === 0) {
        return "Beklemede statüsündeki kuponunuz oynandı anlamına gelmez. Lütfen Barkod numarası (Bilet No) gelene kadar bekleyiniz.";
    }
    return null;
};

export function MemberTickets() {
    const {pathname} = useLocation();
    const [selectedTab, setSelectedTab] = useState(tabs[0]);
    const handleSelect = (e: any) => {
        if (e.target.id) {
            setSelectedTab(tabs[e.target.id]);
        }
    };

    useEffect(() => {
        if (pathname.includes('kayitli')) {
            setSelectedTab(tabs[3]);
        }
    }, [pathname]);

    return (
        <div>
            <div className="page-title-wrapper">
                <div className="container">
                    <div className="">
                        {!isMobile && <p className="text-xsmall member-title pt-4 pb-3">Kuponlarım</p>}
                        <div>
                            <div className="tab-items-wrapper">
                                {tabs.map(({value, label}: { value: string; label: string }, index) => {
                                    if (value === 'hazir-kuponlar' && auth.member?.is_editor !== true) {
                                        return null;
                                    }
                                    return (
                                        <div id={`${index}`} key={`tabs-index-${index}`} onClick={handleSelect}
                                             className={`tab-item ${selectedTab.value === value ? "active" : ""}`}>
                                            <p id={`${index}`} onClick={handleSelect}
                                               className={`text-small ${isMobile ? '' : 'text-small text-bolder'} ${selectedTab.value === value ? "text-primary" : ""} ${selectedTab.value !== value && !isMobile ? 'text-white' : ''}`}
                                            >{label}</p>

                                            {(isMobile || selectedTab.value === value) &&
                                                <div className="tab-active-indicator"></div>}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="">{selectedTab.content}</div>

        </div>
    )
}

// ===== Bilet yardımcıları (saf) =====

const isTicketCombine = (t: any) => !!BettingTypesMap[Number(t?.bet_type)]?.isCombine;
const isTicketLongterm = (t: any) => !!BettingTypesMap[Number(t?.bet_type)]?.isLongterm;
const isTicketHeadToHead = (t: any) => !!BettingTypesMap[Number(t?.bet_type)]?.isHeadToHead;
const isTicketFob = (t: any) => !!BettingTypesMap[Number(t?.bet_type)]?.isFob;
const isTicketSystemCombine = (t: any) => Number(t?.bet_type) === BettingTypeIds.combineSystem;

const ticketSingleRaceNo = (t: any): number | null => {
    if (!isTicketCombine(t)) {
        return Number(t?.race_id);
    }
    const legs = normalizeTicketLegs(t);
    const keys = Array.from(new Set(legs.map((l) => `${l.card}_${l.raceNo}`)));
    return keys.length === 1 ? legs[0].raceNo : null;
};
// 52 ve 62 zaten `isOrdered` taşıyor; listede yalnız 55 (Tabela Bahis Komple) fazladan.
const isOrderedComplete = (betType: any) =>
    !!BettingTypesMap[Number(betType)]?.isOrdered || Number(betType) === 55;

const isTicketComma = (t: any) => isOrderedComplete(t?.bet_type) && t?.legs?.length === 1;

const ticketBetTypeName = (t: any) => {
    const name = BettingTypesMap[Number(t?.bet_type)]?.name;
    return name && isTicketComma(t) ? `${name} (Virgüllü)` : name;
};


const hippodromeNameFor = (card: any): string => {
    const keyword = rowHippodromeKeyword(card).replace('diyarbakir', 'dbakir');
    const record = getHippodromesMap()[keyword];
    return record?.HIPODROM ?? record?.YER ?? keyword.toUpperCase();
};

const ticketPayout = (ticket: any) => {
    const winning = Number(ticket?.winning) || 0;
    const refund = Number(ticket?.refund) || 0;
    const hasPayout = winning > 0 || refund > 0;
    const isRefundOnly = winning <= refund;
    return {
        hasPayout,
        isRefundOnly,
        label: hasPayout && isRefundOnly ? "İade" : "Kazanç",
        winningText: `${ticket?.winning}₺`,
        refundText: refund > 0 ? `( ${ticket?.refund}₺ iade)` : "",
    };
};

function TicketPayoutCell({ticket}: { ticket: any }) {
    const {hasPayout, isRefundOnly, winningText, refundText} = ticketPayout(ticket);
    if (!hasPayout) {
        return <>-</>;
    }
    return (<>
        {!isRefundOnly && winningText}
        {refundText && <span className="d-block fw-normal">{refundText}</span>}
    </>);
}

// Listede "Kazanan" sekmesi ödemeyi, diğer sekmeler kupon tutarını gösteriyor.
function TicketAmountCell({ticket, status}: { ticket: any; status: any }) {
    return status === 2
        ? <TicketPayoutCell ticket={ticket}/>
        : <>{`${CurrencyFormat(Number(ticket.amount || 0))}₺`}</>;
}

const ticketEstimatedWinLabel = (ticket: any): string =>
    Number(ticket?.bet_type) === BettingTypeIds.combineSystem ? "Tahmini Maks. Kazanç" : "Tahmini Kazanç";

const ticketMinWin = (ticket: any): string | null => {
    if (Number(ticket?.bet_type) !== BettingTypeIds.combineSystem) {
        return null;
    }
    const odds: number[] = Array.isArray(ticket.rows)
        ? ticket.rows.map((row: any) => Number(row.odd_ratio) || 1).sort((a: number, b: number) => a - b)
        : [];
    const sizes = String(ticket.system ?? "").split(",")
        .map(Number)
        .filter((k: number) => Number.isFinite(k) && k >= 1 && k <= odds.length);
    if (sizes.length === 0) {
        return null;
    }
    const minOdds = Math.min(...sizes.map((k: number) => odds.slice(0, k).reduce((acc: number, odd: number) => acc * odd, 1)));
    return `${(minOdds * Number(ticket.multiply || 0)).toFixed(2)}₺`;
};

const ticketHippodromeLabel = (ticket: any): string => {
    if (isTicketLongterm(ticket)) {
        const selection: any = ticket.legs?.[0] ? Object.values(ticket.legs[0])[0] : null;
        return selection?.hippodrome ?? '';
    }
    if (ticket?.card) {
        return hippodromeNameFor(ticket.card);
    }
    const legs = normalizeTicketLegs(ticket);
    const labels = Array.from(new Set(
        legs.map((leg) => leg.hippodromeLabel || (leg.card ? hippodromeNameFor(leg.card) : '')).filter(Boolean)
    ));
    if (labels.length === 0) {
        return '';
    }
    return labels.length > 1 ? 'Çoklu' : labels[0];
};

const ticketNumberText = (ticket: any): string =>
    ticket.status !== 6 && ticket.approve_code ? ticket.approve_code : (ticket.status === 6 ? ticket.id : "Oynanıyor");

// Biletin oranı: önce sunucunun `fob_odd_ratio`su, o yoksa BACAK SATIRLARINDAN çarpım.
// KAYITLI kuponlarda sunucu toplam oranı hesaplamıyor - alan hep 1 geliyor - ama satırlar
// oynama anındaki gerçek oranı taşıyor (`fob.service.ts` her satıra `odd_ratio` +
// `is_closing_odd` yazıyor). Hiç satır yoksa uydurulacak bir sayı da yok: "-".
// `hasClosing`: bacaklardan biri kapanış oranlı (KO); o bacak çarpıma girmediği için
// gösterilen rakam EKSİKTİR ve yanına "+ KO" konur.
const ticketOdds = (ticket: any): { total: number | null; hasClosing: boolean; hasRows: boolean } => {
    const rows: any[] = Array.isArray(ticket?.rows) ? ticket.rows : [];
    let product = 1;
    let known = 0;
    let hasClosing = false;
    for (const row of rows) {
        const ratio = Number(row?.odd_ratio);
        if (row?.is_closing_odd === true || !ratio || ratio === 1) {
            hasClosing = true;
            continue;
        }
        product *= ratio;
        known += 1;
    }
    const serverTotal = Number(ticket?.fob_odd_ratio);
    return {
        total: serverTotal > 1 ? serverTotal : (known > 0 ? product : null),
        hasClosing,
        hasRows: rows.length > 0,
    };
};

const ticketHasClosingOdds = (ticket: any): boolean => ticketOdds(ticket).hasClosing;

const ticketOddText = (ticket: any): string => {
    const {total, hasClosing, hasRows} = ticketOdds(ticket);
    if (total !== null) {
        return `${total.toFixed(2)}${hasClosing ? ' + KO' : ''}`;
    }
    // Oran hiçbir yerden çıkmıyor: bütün bacaklar kapanış oranlıysa "KO", değilse "-".
    return hasRows && hasClosing ? 'KO' : '-';
};

// Tahmini kazanç: önce sunucunun tutarı. Sunucu vermiyorsa (KAYITLI kupon) oran × misli ile
// hesaplanır - kupon ekranındaki Maks. Kazanç ile birebir aynı çarpım. SİSTEMLİ kuponda
// hesap yapılmaz: orada tutar kombinasyon sayısına bağlı, yanlış sayı yazmaktansa "-" kalır.
// Sistemli kuponun azami kazancı: seçilen her k için TÜM k'lı kombinasyonların çarpım
// TOPLAMI (elemanter simetrik polinom, e_k) × misli - kupon ekranındaki Maks. Kazanç ile
// aynı sayı. Kapanış oranlı (KO) bacak, kupon ekranındaki gibi 1 sayılır.
const ticketSystemMaxWin = (ticket: any): number | null => {
    const rows: any[] = Array.isArray(ticket?.rows) ? ticket.rows : [];
    if (rows.length === 0) {
        return null;
    }
    const odds = rows.map((row: any) => {
        const ratio = Number(row?.odd_ratio);
        return (row?.is_closing_odd === true || !ratio) ? 1 : ratio;
    });
    const sizes = String(ticket.system ?? '').split(',')
        .map(Number)
        .filter((k: number) => Number.isFinite(k) && k >= 1 && k <= odds.length);
    if (sizes.length === 0) {
        return null;
    }
    const maxK = Math.max(...sizes);
    const e = new Array(maxK + 1).fill(0);
    e[0] = 1;
    for (const odd of odds) {
        for (let j = maxK; j >= 1; j -= 1) {
            e[j] += e[j - 1] * odd;
        }
    }
    return sizes.reduce((acc: number, k: number) => acc + e[k], 0) * (Number(ticket.multiply) || 0);
};

const ticketProfitText = (ticket: any): string => {
    const {total, hasClosing, hasRows} = ticketOdds(ticket);
    const suffix = hasClosing ? ' + KO' : '';
    // Sunucunun tutarı yalnız toplam oranı DA hesapladığında güvenilir: kayıtlı kuponda
    // ikisi de hesaplanmıyor ve `fob_profit` kupon tutarına eşit geliyor (1.00₺ gibi).
    if (Number(ticket?.fob_odd_ratio) > 1 && Number(ticket?.fob_profit) > 0) {
        return `${ticket.fob_profit}₺${suffix}`;
    }
    const multiply = Number(ticket?.multiply) || 0;
    // Sistemli kuponda tutar kombinasyon sayısına bağlı; `system` alanı sistemsiz kuponlarda
    // da dolu geldiği için ölçüt BAHİS TÜRÜ.
    const isSystem = Number(ticket?.bet_type) === BettingTypeIds.combineSystem;
    if (total !== null && multiply > 0) {
        if (!isSystem) {
            return `${CurrencyFormat(total * multiply)}₺${suffix}`;
        }
        const systemMax = ticketSystemMaxWin(ticket);
        if (systemMax !== null) {
            return `${CurrencyFormat(systemMax)}₺${suffix}`;
        }
    }
    return hasRows && hasClosing && total === null ? 'KO' : '-';
};

// Kupon henüz oynanabilir mi: kartın koşusu açık ve bilet "Devam Ediyor".
const isTicketReplayable = (ticket: any): boolean =>
    getBulletinCardId()[Number(ticket.card_id)]?.runsMap?.[ticket.race_id]?.status === 0 && ticket.status === 1;

function normalizeTicketShape(tickets: any) {
    if (!Array.isArray(tickets)) {
        return tickets;
    }
    return tickets.map((ticket: any) => {
        const hasRows = Array.isArray(ticket?.rows) && ticket.rows.length > 0;
        if (!hasRows && Array.isArray(ticket?.legs) && ticket.legs.length > 0) {
            return {
                ...ticket,
                legs: ticket.legs.map((leg: any) => leg !== null && typeof leg === 'object' ? leg : [leg]),
            };
        }
        const normalized = normalizeTicketLegs(ticket);
        if (normalized.length === 0) {
            return ticket;
        }
        const legs = isTicketCombine(ticket)
            ? normalized.map((leg) => ({[`${leg.card}_${leg.raceNo}_${leg.betType}`]: [leg.rawSelections.join('-')]}))
            : normalized.map((leg) => leg.selections);
        return {...ticket, legs, normalizedLegs: normalized};
    });
}

// ===== Tekrar oynatma =====

function replayFobTicketToBetslip(ticket: any, navigate: NavigateFunction): void {
    const rawLegs = normalizeTicketLegs(ticket);

    const legsForReplay: any[] = [];
    for (let i = 0; i < rawLegs.length; i += 1) {
        const leg = rawLegs[i];
        const next = rawLegs[i + 1];
        if (!leg.isCombine && leg.selections.length === 1 && next && !next.isCombine
            && next.selections.length === 1 && next.card === leg.card
            && next.raceNo === leg.raceNo && next.betType === leg.betType) {
            legsForReplay.push({
                ...leg,
                selections: [leg.selections[0], next.selections[0]],
                rawSelections: [leg.rawSelections[0], next.rawSelections[0]],
            });
            i += 1;
            continue;
        }
        legsForReplay.push(leg);
    }

    // Bacaklar ÖNCE eksiksiz doğrulanıp toplanıyor; sepet ancak hepsi geçerliyse yazılıyor.
    const itemsToPlay = legsForReplay.map((leg: any) => {
        const legHippodrome = getAvailableHippodromes().find(
            (h: any) => `${h._date}-${h.keyword.toLowerCase()}` === leg.card
        );
        const run = legHippodrome?.runsMap?.[Number(leg.raceNo)];
        const legLabel = `${legHippodrome?.hippodrome ?? leg.hippodromeLabel ?? leg.card} ${leg.raceNo}. koşu`;
        if (!legHippodrome || !run) {
            throw new Error(`${legLabel} artık bültende yok.`);
        }

        const suffix = BettingTypesMap[Number(leg.betType)]?.suffix ?? '';
        const item = leg.selections.length === 2
            ? {
                hippodrome: legHippodrome, run, bettingType: Number(leg.betType),
                oddKey: `${canonicalFobPairOrder(leg.betType, leg.selections[0], leg.selections[1]).join('-')}${suffix}`,
                horseNos: leg.selections,
            }
            : {
                hippodrome: legHippodrome, run, bettingType: Number(leg.betType),
                oddKey: leg.rawSelections[0],
                horseNos: [leg.selections[0]],
            };

        // Kim Geçer'in oranı `event_odds`ta değil koşunun `fob_h2h`sinde; pazarın açık olup
        // olmadığını `fob_h2h_status` söylüyor - bahis sayfasındaki kuralın aynısı.
        if (!!BettingTypesMap[Number(leg.betType)]?.isHeadToHead
            && !(run.fob_h2h_status && run.fob_h2h && Object.keys(run.fob_h2h).length > 0)) {
            throw new Error(`${legLabel} için Kim Geçer bahsi kapandı.`);
        }
        if (!isFobItemPlayable(item)) {
            throw new Error(`${legLabel} - ${item.horseNos.join('-')} seçimi artık oynanamıyor (at koşmuyor ya da oranlar kapanmış olabilir).`);
        }
        return item;
    });

    if (itemsToPlay.length === 0) {
        throw new Error("Bu kuponun bacakları çözümlenemedi.");
    }

    FOBBetslip.clear();
    itemsToPlay.forEach((item: any) => FOBBetslip.add(item));
    // Sistemli kombinede seçilen sistem de geri yükleniyor; `clear()` bu alanı sıfırlamadığı
    // için sistemsiz kuponlarda açıkça boşaltmak gerekiyor.
    FOBBetslip.setOptions({
        multiply: ticket.multiply,
        fobSystemSelected: Number(ticket.bet_type) === BettingTypeIds.combineSystem && ticket.system
            ? String(ticket.system).split(',').map(Number).filter((k: number) => Number.isFinite(k) && k >= 1 && k <= itemsToPlay.length)
            : [],
    });

    const firstItem: any = itemsToPlay[0];
    const firstHippodrome: any = firstItem.hippodrome;

    navigate(`${paths.bettingFob.url}/${firstHippodrome.keyword.toLowerCase()}${firstHippodrome._id}`, {
        state: {fobSelection: {bettingTypeId: Number(firstItem.bettingType), runNo: Number(firstItem.run?.no)}},
    });
}

// ===== Koşu / sonuç çözümlemesi =====

type LegData = { runs: Record<string, any>; scores: Record<string, string> };
const emptyLegData: LegData = {runs: {}, scores: {}};

const horseSeparator = ',';
const runSeparator = '/';

const getStableMate = (horses: any, horse: any) => {
    if (horse.stablemate && Number(horse.stablemate) > 0) {
        return horses.filter((e: any) => Number(e.stablemate) === Number(horse.stablemate))
    }
    return [];
}

// Bir koşunun kazananlarını hesaplar (ayak/kolon başına "kazanan at numaraları" dizesi).
// Mantık aynen korundu; artık haritaya yazmak yerine değeri döndürüyor.
function computeRunScore(run: any, betType: number): string | null {
    if (!run || !Array.isArray(run.horses)) {
        return null;
    }
    const info: any = BettingTypesMap[Number(betType)];
    if (!info || !!info.isFavoriteExcluded) {
        return null;
    }

    const fobTopN = fobTopNScore(run, betType);
    if (fobTopN !== null) {
        return fobTopN;
    }

    // 52/62 zaten `isOrdered` taşıyor; listede yalnız 55 (Tabela Bahis Komple) fazladan.
    const isOrderedLike = !!info.isOrdered || Number(betType) === 55;

    if (isOrderedLike) {
        const horses = _.orderBy(
            run.horses.filter((el: any) => el.result !== "" && el.result !== null),
            [(e: any) => Number(e.result)]
        );
        const winners: any[] = [];
        if ([47, 48].includes(Number(betType))) {
            if (horses[0]) winners.push(horses[0].no);
            if (horses[1]) winners.push(horses[1].no);
            if (horses[2]) winners.push(horses[2].no);
            return run.is_finished !== false ? winners.join(horseSeparator) : "-";
        }
        let value = "-";
        for (let i = 0; i < Number(info.column ?? 0); i += 1) {
            if (run.is_finished !== false && horses[i]) {
                winners.push(horses[i].no);
                value = winners.join(runSeparator);
            } else {
                value = "-";
            }
        }
        return value;
    }

    if (!!info.isCommaType || !!info.isSingleColumn) {
        const horses = _.orderBy(
            run.horses.filter((el: any) => el.result !== "" && el.result !== null),
            [(e: any) => Number(e.result)]
        );
        const winners: any[] = [];
        for (let i = 0; i < Number(info.horseCount ?? 0); i += 1) {
            if (horses[i]) winners.push(horses[i].no);
        }
        return winners.join(runSeparator);
    }

    // Çok ayaklı bahislerde ayak kazananı: birincilik + ekürisi, beraberlik ve
    // AGF koşulu (7'li Ganyan) dâhil.
    const horses = _.orderBy(run.horses, (e: any) => Number(e.result === "" || e.result === null ? 99999 : e.result));
    if (!run.is_finished || !horses[0]) {
        return "-";
    }
    const winners: any[] = [horses[0].no];
    const firstStablemate = getStableMate(horses, horses[0]);
    if (firstStablemate.length > 0) {
        winners.push(...firstStablemate.map((e: any) => e.no));
    }
    if (horses[1] && String(horses[0].result) === "1" && String(horses[1].result) === "1") {
        winners.push(horses[1].no);
        const secondStablemate = getStableMate(horses, horses[1]);
        if (secondStablemate.length > 0) {
            winners.push(...secondStablemate.map((e: any) => e.no));
        }
    }
    if (!!info.isAGFCondition) {
        let agfApplies = 0;
        if (horses[0].AGF_rank1 && Number(horses[0].AGF_rank1) === 1) {
            agfApplies = 1;
        }
        if (horses[0].EFG) {
            agfApplies = 1;
        }
        if (agfApplies === 1) {
            const notRun = horses.filter((e: any) => e.degree === null && (e.result === null || e.result === ""));
            for (const noRun of notRun) {
                winners.push(noRun.no);
                const sm = getStableMate(horses, noRun);
                if (sm.length > 0) {
                    winners.push(...sm.map((e: any) => e.no));
                }
            }
        }
        if (Number(betType) === 19 && horses[1]) {
            winners.push(horses[1].no);
            winners.push(...getStableMate(horses, horses[1]).map((e: any) => e.no));
            winners.push(...getStableMate(horses, horses[0]).map((e: any) => e.no));
        }
    } else if ([47, 48].includes(Number(betType))) {
        if (horses[1]) winners.push(horses[1].no);
        if (horses[2]) winners.push(horses[2].no);
        if (horses[3]) winners.push(horses[3].no);
    } else if ([2, 4].includes(Number(betType))) {
        if (horses[1]) winners.push(horses[1].no);
    }
    return [...Array.from(new Set(winners))].join(horseSeparator);
}

function withResolvedAgf(run: any) {
    if (!run || !Array.isArray(run.horses)) {
        return run;
    }
    const ratio = (horse: any, pool: number) => {
        const value = Number(String(horse[`AGF${pool}`] ?? horse[`agf_ratio${pool}`] ?? '').replace(',', '.'));
        return Number.isFinite(value) && value > 0 ? value : undefined;
    };
    return {
        ...run,
        horses: run.horses.map((horse: any) => {
            const AGF1 = ratio(horse, 1);
            const AGF2 = ratio(horse, 2);
            return {
                ...horse,
                AGF1,
                AGF2,
                AGF_rank1: AGF1 === undefined ? undefined : (horse.AGF_rank1 ?? horse.agf_sort_no1),
                AGF_rank2: AGF2 === undefined ? undefined : (horse.AGF_rank2 ?? horse.agf_sort_no2),
            };
        }),
    };
}

async function resolveTicketLegData(ticket: any): Promise<LegData> {
    const data: LegData = {runs: {}, scores: {}};
    if (isTicketLongterm(ticket)) {
        return data;
    }
    const legs = normalizeTicketLegs(ticket);
    if (legs.length === 0) {
        return data;
    }
    const cards = await resolveTicketCards(legs);
    for (const leg of legs) {
        const resolved = cards.get(leg.card);
        const run = resolved?.runsByNo[String(leg.raceNo)];
        if (!run) {
            continue;
        }
        const withAgf = withResolvedAgf(run);
        data.runs[`${leg.card}-${leg.raceNo}`] = withAgf;
        if (leg.cardId != null) {
            data.runs[`${leg.cardId}-${leg.raceNo}`] = withAgf;
        }
        if (ticket.card_id != null) {
            data.runs[`${ticket.card_id}-${leg.raceNo}`] = withAgf;
        }
        const score = computeRunScore(withAgf, FOB_TOP_N[leg.betType] ? leg.betType : Number(ticket.bet_type));
        if (score !== null) {
            data.scores[`${leg.card}-${ticket.bet_type}-${leg.raceNo}`] = score;
            if (ticket.card_id != null) {
                data.scores[`${ticket.card_id}-${ticket.bet_type}-${leg.raceNo}`] = score;
            }
        }
    }
    return data;
}

function stripOddKeySuffix(value: any): string {
    return String(value ?? '')
        .replaceAll('H2H', '').replaceAll('EX', '')
        .replaceAll('T2', '').replaceAll('T3', '').replaceAll('T4', '').replaceAll('T5', '').replaceAll('WW', '');
}

function resolveLegHorses(horses: any, rawSelection: any): any[] {
    return stripOddKeySuffix(rawSelection)
        .split('-')
        .filter((no: string) => no !== '')
        .map((no: string) => (horses ?? []).find((el: any) => Number(el.no) === Number(no)) ?? null);
}

function findLegOdd(ticket: any, card: any, raceNo: any, legKey: any, selection: any): string | null {
    const rows = Array.isArray(ticket?.rows) ? ticket.rows : [];
    // Tek bahisli bilette bacağın oranı ile üstteki "Toplam Oran" birebir aynı sayı olur.
    if (rows.length < 2) {
        return null;
    }
    const betType = String(legKey).split('_')[2] ?? ticket.bet_type;
    const cleanSelection = stripOddKeySuffix(selection);
    const row = rows.find((el: any) =>
        String(el.card) === String(card) &&
        String(el.race_id) === String(raceNo) &&
        String(el.bet_type) === String(betType) &&
        stripOddKeySuffix(el.odd_key) === cleanSelection
    );
    if (!row || row.odd_ratio == null) {
        return null;
    }
    const ratio = Number(row.odd_ratio);
    return row.is_closing_odd === true || !ratio || ratio === 1 ? 'KO' : ratio.toFixed(2);
}

function combineLegTypeLabel(legKey: string, rawSelection: any): string {
    const betType = Number(String(legKey).split('_')[2]);
    // Ganyan ve Kapanış Oranı listede yoktu: o bacaklar tür sütunu BOŞ çiziliyordu.
    if (betType === 1881) return 'GNY';
    if (betType === BettingTypeIds.closingOdds) return 'KO';
    if (betType === 1885) return 'Sıralı İkili';
    if (betType === 1884) return 'İkili Bahis';
    if (betType === 1886) return 'İlk 2';
    if (betType === 1887) return 'İlk 3';
    if (betType === 1888) return 'İlk 4';
    if (betType === 1893) return 'İlk 5';
    if (betType === BettingTypeIds.headToHead) return 'Kim Geçer';
    const val = String(rawSelection ?? '');
    if (val.includes('T2')) return 'İlk 2';
    if (val.includes('T3')) return 'İlk 3';
    if (val.includes('T4')) return 'İlk 4';
    if (val.includes('T5')) return 'İlk 5';
    // Listede olmayan tür için katalogdaki kısa ad (mobil `defineBetType` de böyle düşüyor).
    return BettingTypesMap[betType]?.prefix ?? BettingTypesMap[betType]?.name ?? '';
}

// ===== Bacak çizimi =====

type Variant = 'mobile' | 'desktop';

// AGF çubuğu. Eskiden aynı 40 satırlık işaretleme 12 kez kopyalanmıştı.
function AgfBar({value, rank, first}: { value: any; rank: any; first: boolean }) {
    return (
        <div style={{width: "87px", margin: first ? "auto 12px auto auto" : "auto"}}>
            <div style={{position: "relative", minWidth: "80px"}}>
                <div style={{height: "16px", width: `${value}%`, backgroundColor: "rgb(232, 230, 208)", borderRadius: "0px"}}></div>
                <div style={{
                    position: "absolute", top: "0px", width: "87px", height: "100%", display: "flex",
                    alignItems: "center", justifyContent: "center", borderRadius: "2px",
                    border: "1px solid rgb(217, 217, 217)"
                }}>
                    <p className="text-xxxsmall text-center">
                        <span className="text-xxsmall text-bolder">AGF: </span>{value} ({rank})
                    </p>
                </div>
            </div>
        </div>
    );
}

// İki altılı havuzu (1. altılı `AGF1`, 2. altılı `AGF2`): yalnız dolu olan(lar) çiziliyor.
function AgfBars({horse, betType}: { horse: any; betType: any }) {
    if (!BettingTypesMap[Number(betType)]?.isAGFCondition) {
        return null;
    }
    return (
        <div className="d-flex">
            {horse?.AGF1 && <AgfBar value={horse.AGF1} rank={horse.AGF_rank1} first={true}/>}
            {horse?.AGF2 && <AgfBar value={horse.AGF2} rank={horse.AGF_rank2} first={false}/>}
        </div>
    );
}

function StablemateMark({horse, betType}: { horse: any; betType: any }) {
    if (!BettingTypesMap[Number(betType)]?.isAGFCondition || !horse || !Number(horse.stablemate)) {
        return null;
    }
    return <span className="d-flex align-items-center ms-1"><GetStablemateIcon horse={horse}/></span>;
}

const legTextClass = (variant: Variant) => variant === 'mobile' ? 'text-small fw-regular' : 'text-xxsmall';
const legMarkClass = (variant: Variant) => variant === 'mobile' ? 'text-small fw-regular ms-2 me-1' : 'text-xxsmall fw-medium ms-2 me-1';

// Koşu bitti mi: derece/sonuç; bitmediyse koşmayan at "(K)". Biletin İLK koşusunun
// `is_finished` bayrağına bakılıyor (eski davranış).
function ResultMark({ticket, legData, horse, isWinner, variant}: { ticket: any; legData: LegData; horse: any; isWinner: boolean; variant: Variant }) {
    const firstRun = legData.runs[`${ticket.card_id}-${ticket.race_id}`];
    let text = '';
    if (firstRun?.is_finished) {
        if (horse) {
            text = !horse.result && horse.degree === null ? '(K)' : (horse.result ? `(${horse.result})` : '');
        }
    } else if (horse?.run_status === false) {
        text = '(K)';
    }
    return (
        <p className={legMarkClass(variant)} style={{width: "10px", color: isWinner ? 'green' : 'var(--text-color)'}}>{text}</p>
    );
}

function LegHeader({children, variant}: { children: React.ReactNode; variant: Variant }) {
    return (
        <button className={`button w-100 tertiary filled leg-button selected`}>
            <p className={variant === 'mobile' ? "text-small " : "text-small text-bolder"}>{children}</p>
        </button>
    );
}

function ClassicLegs({ticket, legData, variant}: { ticket: any; legData: LegData; variant: Variant }) {
    const info = BettingTypesMap[Number(ticket.bet_type)];
    const columnLabel = info?.columnLabel;
    return (
        <div>
            {ticket.legs.map((leg: any, key: number) => {
                // 'At' kolonlu türlerde bütün kolonlar AYNI koşudan; diğerlerinde her ayak sonraki koşu.
                const runNo = columnLabel !== "At" ? Number(ticket.race_id) + Number(key) : Number(ticket.race_id);
                const run = legData.runs[`${ticket.card_id}-${runNo}`];
                let scoreString: any = legData.scores[`${ticket.card_id}-${ticket.bet_type}-${Number(ticket.race_id) + (columnLabel === "At" ? 0 : key)}`];
                if (!!info?.isSingleColumn || isTicketComma(ticket)) {
                    scoreString = scoreString?.toString().replaceAll("/", ",");
                }
                const colScore: any = ([47, 48].includes(Number(ticket.bet_type)) || columnLabel === "At")
                    ? scoreString?.split(runSeparator)[0]
                    : scoreString;

                return <div className={"mb-1 ticket-run-container"} key={"ticket-leg-" + key}>
                    <LegHeader variant={variant}>
                        {columnLabel === 'Koşu' ? Number(ticket.race_id) + Number(key) : Number(key + 1)}. {columnLabel}
                    </LegHeader>

                    {leg.map((item: any, horseKey: number) => {
                        const horse = run ? (run.horses ?? []).find((e: any) => Number(e.no) === Number(item)) : null;
                        const isWinner = !!(horse && scoreString && colScore?.split(horseSeparator)?.includes(horse.no));
                        return <div key={"leg-" + horseKey + key} className="d-flex justify-content-between ticket-run-horse">
                            <p className={`${legTextClass(variant)} d-flex`}
                               style={{color: isWinner ? 'green' : 'var(--text-color)'}}>
                                {horse
                                    ? <> {horse.no} - {horse.name} </>
                                    : <>{Number(item) === 32 ? (mobileView ? '(S)' : 'HAZIR BAHİS') : String(item)}</>}
                                <StablemateMark horse={horse} betType={ticket.bet_type}/>
                            </p>
                            <div className="d-flex">
                                <AgfBars horse={horse} betType={ticket.bet_type}/>
                                {run && <ResultMark ticket={ticket} legData={legData} horse={horse} isWinner={isWinner} variant={variant}/>}
                            </div>
                        </div>
                    })}
                </div>
            })}
        </div>
    );
}

function LongtermLeg({ticket}: { ticket: any }) {
    if (!ticket.legs?.[0]) {
        return null;
    }
    const selection: any = Object.values(ticket.legs[0])[0];
    return <div className={"mb-1 ticket-run-container"}>
        <button className={`button w-100 tertiary filled leg-button selected`}>
            <p className="text-small text-bolder">{selection.hippodrome}</p>
        </button>
        <div className="d-flex justify-content-between ticket-run-horse">
            <p className="text-small fw-regular">{selection.description}</p>
            <p className="text-small text-bolder">{ticketOddText(ticket)}</p>
        </div>
    </div>;
}

// Kim Geçer'in bilet detayı: iki at AYNI koşuda ve biri RAKİP. Klasik ayak çizimi bunları
// ardışık iki koşu sanıp "8. Koşu / 9. Koşu" diye gösteriyordu. Tek kutuda, "vs" ile.
function TicketH2HLegs({ticket, legData}: { ticket: any; legData: LegData }) {
    const legs = ticket.normalizedLegs ?? normalizeTicketLegs(ticket);
    return (<div>
        {legs.map((leg: any, key: number) => {
            const run = legData.runs[`${leg.card}-${leg.raceNo}`]
                ?? legData.runs[`${ticket.card_id}-${leg.raceNo}`];
            const named = leg.selections.map((no: string) => {
                const horse = (run?.horses ?? []).find((h: any) => Number(h.no) === Number(no));
                return horse ? `${horse.no} - ${horse.name}` : no;
            });
            return (<div className={"mb-1 ticket-run-container"} key={`h2h-leg-${key}`}>
                <button className={"button w-100 tertiary filled leg-button selected"}>
                    <p className="text-small">{leg.raceNo}. {BettingTypesMap[Number(leg.betType)]?.columnLabel ?? 'Koşu'}</p>
                </button>
                <div className="d-flex justify-content-between ticket-run-horse">
                    {/* İlk at kullanıcının SEÇTİĞİ at, ikincisi rakip. */}
                    <p className="text-small fw-regular">
                        <span className="h2h-picked-horse">{named[0]}</span>
                        {named.length > 1 && <span>{` vs ${named.slice(1).join(' vs ')}`}</span>}
                    </p>
                </div>
            </div>);
        })}
    </div>);
}

// Kombine biletler: her bacak kendi kartı/koşusu/türüyle bir kutu; bacak oranı `rows`tan.
function CombineLegs({ticket, legData, variant}: { ticket: any; legData: LegData; variant: Variant }) {
    const columnLabel = BettingTypesMap[Number(ticket.bet_type)]?.columnLabel;
    return (
        <div>
            {ticket.legs.map((leg: any, key: number) => {
                const previousLeg = key > 0 ? ticket.legs[key - 1] : null;
                const isLegacyPairHalf = (l: any) =>
                    !String((Object.values(l ?? {})[0] as any)?.[0] ?? '').includes('-');
                if (previousLeg
                    && Object.keys(leg)[0] === Object.keys(previousLeg)[0]
                    && isLegacyPairHalf(leg) && isLegacyPairHalf(previousLeg)) {
                    return null;
                }

                const legKey: string = Object.keys(leg)[0];
                let card: any = legKey.split('_')[0];
                let cardRunNo: any = legKey.split('_')[1];
                const betType = legKey.split('_')[2];
                if (!legKey.includes('_')) {
                    card = ticket.card_id;
                    cardRunNo = ticket.race_id;
                }
                const run = cardRunNo ? legData.runs[`${card}-${cardRunNo}`] : legData.runs[`${legKey.replaceAll('_', '-')}`];

                return <div className={"mb-1 ticket-run-container"} key={"ticket-leg-" + key}>
                    <button className={`button w-100 tertiary filled leg-button selected d-flex justify-content-between align-items-center`}>
                        <p>{run?.hippodrome}</p>
                        <p>{combineLegTypeLabel(legKey, leg[legKey]?.[0])}</p>
                        <p className="text-small text-bolder">{cardRunNo}. {columnLabel}</p>
                    </button>

                    {Object.keys(leg).map((item: any, horseKey: number) => {
                        const rawSelection = leg[item]?.[0];
                        // Koşu hiç yüklenmemişse ham seçim yazılıyor (eskiden burada bacak NESNESİ
                        // React child olarak basılıp sayfa çöküyordu).
                        if (!run) {
                            return (
                                <div key={`order-detail-horse-${horseKey}`}
                                     className="horse-no d-flex justify-content-between"
                                     style={mobileView ? {background: "var(--color-bg-white)"} : {}}>
                                    <div className={"text-left "} style={{paddingLeft: 5}}>{String(rawSelection ?? '')}</div>
                                    <div style={{paddingRight: 5}}></div>
                                </div>
                            );
                        }

                        const resolved = resolveLegHorses(run.horses, rawSelection);
                        const horse = resolved[0] ?? null;
                        let horse2 = resolved[1] ?? null;
                        if (!horse2 && ticket.legs.length - 1 > key && item === Object.keys(ticket.legs[key + 1])[0]) {
                            horse2 = resolveLegHorses(run.horses, ticket.legs[key + 1][item][0])[0] ?? null;
                        }

                        let scoreString: any = legData.scores[`${card}-${ticket.bet_type}-${cardRunNo}`];
                        if (!!BettingTypesMap[Number(ticket.bet_type)]?.isSingleColumn) {
                            scoreString = scoreString?.toString().replaceAll("/", ",");
                        }
                        const colScore: any = columnLabel === "At" ? scoreString?.split(runSeparator)[0] : scoreString;
                        const isWinner = !BettingTypesMap[Number(betType)]?.isFavoriteExcluded
                            && !!(horse && scoreString && colScore?.split(horseSeparator)?.includes(horse.no));

                        // Bacağın kendi oranı; kombine bilette çarpımın yanında bu da gösteriliyor.
                        const legOdd = findLegOdd(ticket, card, cardRunNo, item, rawSelection);

                        // İkili'de (1884) oynama sırası anlamsız, küçük numara önce; diğer çiftlerde
                        // (Sıralı İkili, Kim Geçer) oynanan sıra korunuyor. Kim Geçer'de iki at RAKİP.
                        const pairHorses = horse && horse2
                            ? (Number(betType) === 1884 && Number(horse.no) > Number(horse2.no) ? [horse2, horse] : [horse, horse2])
                            : null;
                        const isH2HLeg = !!BettingTypesMap[Number(betType)]?.isHeadToHead;
                        const horseName = !pairHorses
                            ? (horse ? `${horse.no} - ${horse.name}` : String(rawSelection ?? ''))
                            : isH2HLeg
                                ? <span><span className="h2h-picked-horse">{`${pairHorses[0].no} - ${pairHorses[0].name}`}</span>{` vs ${pairHorses[1].no} - ${pairHorses[1].name}`}</span>
                                : `${pairHorses[0].no} - ${pairHorses[0].name} - ${pairHorses[1].no} - ${pairHorses[1].name}`;

                        return <div key={"leg-" + key + '-' + horseKey} className="d-flex justify-content-between ticket-run-horse">
                            <p className={`${legTextClass(variant)} d-flex`}
                               style={{color: isWinner ? 'green' : 'var(--text-color)'}}>
                                {horseName}
                                <StablemateMark horse={horse} betType={ticket.bet_type}/>
                            </p>
                            <div className="d-flex">
                                <AgfBars horse={horse} betType={ticket.bet_type}/>
                                {legOdd && <p className="text-xxsmall fw-medium ms-2 text-nowrap">Oran: <b>{legOdd}</b></p>}
                                <ResultMark ticket={ticket} legData={legData} horse={horse} isWinner={isWinner} variant={variant}/>
                            </div>
                        </div>
                    })}
                </div>
            })}
        </div>
    );
}

function TicketLegs({ticket, legData, variant}: { ticket: any; legData: LegData; variant: Variant }) {
    if (isTicketHeadToHead(ticket)) {
        return <TicketH2HLegs ticket={ticket} legData={legData}/>;
    }
    if (isTicketLongterm(ticket)) {
        return <LongtermLeg ticket={ticket}/>;
    }
    if (isTicketCombine(ticket)) {
        return <CombineLegs ticket={ticket} legData={legData} variant={variant}/>;
    }
    return <ClassicLegs ticket={ticket} legData={legData} variant={variant}/>;
}

// ===== Detay modalı =====

function TicketSummaryRows({ticket, variant}: { ticket: any; variant: Variant }) {
    const mobile = variant === 'mobile';
    const labelClass = mobile ? "" : "text-xsmall";
    const valueClass = mobile ? "" : "text-xsmall text-bold";
    const Row = ({label, children}: { label: string; children: React.ReactNode }) => (
        <div className="ticket-detail-row">
            <p className={labelClass}>{label}</p>
            <p className={valueClass}>{children}</p>
        </div>
    );
    const showOdds = isTicketFob(ticket) || isTicketLongterm(ticket);

    return (<>
        {mobile ? (
            <Row label="Bahis Durumu"><span style={{color: statusMap[ticket.status].class}}>{statusMap[ticket.status].label}</span></Row>
        ) : (
            <div className="pt-4 ticket-detail-row flex-wrap">
                <p className="text-xsmall text-bold">{ticketBetTypeName(ticket)}</p>
                <div className="d-flex justify-content-between flex-wrap align-items-center">
                    <p className="text-xsmall text-bold me-1" style={{color: statusMap[ticket.status].class}}>{statusMap[ticket.status].label}</p>
                    <span dangerouslySetInnerHTML={{__html: statusMap[ticket.status].icon}}></span>
                </div>
            </div>
        )}
        <Row label={mobile ? "Bilet Numarası" : "Kupon No"}>{ticketNumberText(ticket)}</Row>
        <Row label="Tarih">{dateTimeFormat(ticket.approve_date).replace(' ', ' , ')}</Row>
        {!isTicketCombine(ticket) && <Row label="Hipodrom">{ticketHippodromeLabel(ticket)}</Row>}
        {mobile && <Row label="Bahis Türü">{ticketBetTypeName(ticket)}</Row>}
        {(isTicketLongterm(ticket) || ticketSingleRaceNo(ticket) !== null) &&
            <Row label="Koşu">{isTicketLongterm(ticket) ? '-' : ticketSingleRaceNo(ticket)}</Row>}
        {mobile && !showOdds && <Row label="Misli">{ticket.multiply}</Row>}
        {showOdds && <Row label={mobile ? "Toplam Oran" : "Oran"}>{ticketOddText(ticket)}</Row>}
        {!mobile && !showOdds && <Row label="Misli">{ticket.multiply}</Row>}
        <Row label={mobile ? "Tutar" : "Kupon Tutarı"}>{CurrencyFormat(Number(ticket.amount || 0))}₺</Row>
        {(isTicketSystemCombine(ticket) && ticket.system) &&
            <div className="ticket-detail-row">
                <p className="">Sistem</p>
                <p className="">{ticket.system.replaceAll(',', '-')}</p>
            </div>}
        {ticketMinWin(ticket) && <Row label="Min. Kazanç">{ticketMinWin(ticket)}</Row>}
        {showOdds &&
            <div className="ticket-detail-row">
                <p className={labelClass}>{ticketEstimatedWinLabel(ticket)}</p>
                <div className="d-flex align-items-center">
                    <p className={`${valueClass} mb-0`}>{ticketProfitText(ticket)}</p>
                    {/* Bilet sonuçlanmadan önce tutar bir projeksiyon; ikon bunu açıklıyor. */}
                    {Number(ticket.fob_odd_ratio) > 1 && ![2, 3, 4, 5].includes(Number(ticket.status)) &&
                        <img src={iconInfo} alt="Bilgi" width={mobile ? 18 : 16} height={mobile ? 18 : 16}
                             className="ms-2" style={{cursor: 'pointer'}}
                             onClick={showEstimatedWinInfoModal}/>}
                </div>
            </div>}
        {ticket.status === 2 &&
            <Row label={mobile ? ticketPayout(ticket).label : `${ticketPayout(ticket).label} Tutarı`}><TicketPayoutCell ticket={ticket}/></Row>}
    </>);
}

const detailModalStyle = () => ({
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: isMobile ? '98%' : '1140px',
        maxHeight: '759px',
        marginRight: '-50%',
        maxWidth: '472px',
        padding: '0',
        transform: 'translate(-50%, -50%)',
        background: 'var(--bs-white)',
        borderRadius: 'var(--bs-border-radius-xl)',
        border: 0
    },
    overlay: {
        zIndex: 5,
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        backdropFilter: 'blur(10px)',
    }
});

function TicketDetailModal({ticket, legData, onClose, onCancel, onPlay}: {
    ticket: any; legData: LegData; onClose: () => void; onCancel: (t: any) => void; onPlay: (t: any) => void;
}) {
    const variant: Variant = isMobile ? 'mobile' : 'desktop';
    return (
        <Modal isOpen={ticket !== null} onRequestClose={onClose} ariaHideApp={false} style={detailModalStyle()} contentLabel="">
            {ticket &&
                <div>
                    <div className="modal-header">
                        <img src={shareIcon} className={"invert-color"} alt={"Paylaş"} onClick={() => {
                            shareOnSocial("ticket-detail-container");
                        }}/>
                        <h3 className="text-lg mb-0 text-white text-bolder text-center w-100">Kupon Detay</h3>
                        <svg onClick={onClose} width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                    </div>
                    <div className="ticket-modal-body" id={"ticket-detail-container"}>
                        <div className={"justify-content-center align-items-center w-100 bg-green"} style={{display: 'none'}}>
                            <img alt={"ekuri"} height={40} className={"mt-1 mb-1"} src="/assets/logo.png"/>
                        </div>
                        <TicketSummaryRows ticket={ticket} variant={variant}/>
                        <div className={variant === 'mobile' ? "mt-3 mb-5" : "mt-3 mb-3"}>
                            <TicketLegs ticket={ticket} legData={legData} variant={variant}/>
                        </div>
                        {/* Mobilde işlemler detayın altında; masaüstünde listedeki satırda. FOB kuponu
                            iptal edilemez; mobil blok FOB'da hiç gösterilmiyor (eski davranış). */}
                        {variant === 'mobile' && isTicketReplayable(ticket) && !isTicketFob(ticket) &&
                            <div className="d-flex justify-content-center align-items-center col-gap-8 detail-btns">
                                <button onClick={() => onCancel(ticket)}
                                        className="button xs danger  mobile-ticket-cancel-btn me-1 button-center">
                                    İptal Et
                                </button>
                                <button className="button xs primary filled mobile-ticket-detail-btn  button-center"
                                        onClick={() => onPlay(ticket)}>
                                    <p className="text-small  text-primary text-bold">Tekrar Oyna</p>
                                </button>
                            </div>}
                    </div>
                </div>
            }
        </Modal>
    );
}

// ===== Liste =====

function EmptyList({mobile}: { mobile: boolean }) {
    return (
        <div className={mobile ? "mb-5" : "mt-2"}>
            <div style={{marginBottom: "150px", marginTop: "150px"}}>
                <div className="d-flex mt-5" style={{justifyContent: "center"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                        <path
                            d="M39.9993 53.3333V40M39.9993 26.6666H40.0327M73.3327 40C73.3327 58.4095 58.4088 73.3333 39.9993 73.3333C21.5899 73.3333 6.66602 58.4095 6.66602 40C6.66602 21.5905 21.5899 6.66663 39.9993 6.66663C58.4088 6.66663 73.3327 21.5905 73.3327 40Z"
                            stroke="#929191" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                </div>
                <p className={`text-xl ${mobile ? 'fw-regular' : 'text-bolder'} text-center mb-1`}>Listelenecek devam eden kuponunuz
                    bulunmamaktadır{mobile ? '.' : ''}</p>
                <p className="text-small text-center mb-5"></p>
            </div>
        </div>
    );
}

// Mobil liste kartı: tıklanınca detay modalı açılıyor.
function MobileTicketCard({ticket, status, onClick, onPlay, onDelete}: {
    ticket: any; status: any; onClick: () => void; onPlay: (t: any) => void; onDelete: (t: any) => void;
}) {
    const hint = pendingStatusHint(ticket.status);
    // Kayıtlı kuponlar (status 6) masaüstünde satırın sağında "Hemen Oyna" + sil taşıyor;
    // mobilde bu iki eylem hiçbir yerde yoktu (detay modalı da yalnız status 1 için çiziyor),
    // yani kayıtlı kupon mobilde OYNANAMIYORDU. Aynı ikili buraya kondu.
    const isSaved = status === 6;
    return (
        <div className="mobile-ticket-wrapper" onClick={onClick}>
            <div className="mobile-ticket-detail-row pb-2" style={{justifyContent: "space-between", borderBottom: "1px solid rgb(146, 145, 145)"}}>
                <p className="text-medium text-bold">{ticketBetTypeName(ticket)}</p>
                <div className="d-flex align-items-center status-box" style={{background: statusMap[ticket.status].style}}>
                    <p className="text-white">{statusMap[ticket.status].label}</p>
                </div>
            </div>

            <div className="mobile-ticket-detail-row pt-2">
                <p className="text-xsmall">{dateTimeFormat(ticket.approve_date ?? ticket.create_date).replace(' ', ' | ')} | {ticketHippodromeLabel(ticket)}</p>
                <p><TicketAmountCell ticket={ticket} status={status}/></p>
            </div>

            {hint && <p className="my-1 alert alert-warning p-2 text-xxsmall fw-bold">{hint}</p>}

            {isSaved &&
                <div className="ticket-play-or-delete pt-2" onClick={(e) => e.stopPropagation()}>
                    <button onClick={() => onPlay(ticket)} className="button xs tertiary outlined play-saved-ticket">
                        <span className="text-xsmall text-primary fw-medium d-flex justify-content-center align-items-center">Hemen Oyna</span>
                    </button>
                    <div onClick={() => onDelete(ticket)} className="delete-saved-ticket d-flex justify-content-center align-items-center">
                        {TRASH_ICON}
                    </div>
                </div>}
        </div>
    );
}

const COPY_ICON = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4.23779" y="2.08345" width="5.67949" height="5.68011" rx="1.25" stroke=" #929191" strokeWidth="1.5"></rect>
        <path d="M7.84632 9.23151V9.23151C7.84632 10.0246 7.20339 10.6675 6.41029 10.6675H3.3335C2.22893 10.6675 1.3335 9.7721 1.3335 8.66753V5.59004C1.3335 4.79702 1.97637 4.15414 2.76939 4.15414V4.15414"
              stroke=" #929191" strokeWidth="1.5"></path>
    </svg>
);

const TRASH_ICON = (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M0.977084 2.86733H4.23876V1.09069C4.23876 0.532137 4.69546 0.0754395 5.25379 0.0754395H9.7462C10.3048 0.0754395 10.7615 0.532137 10.7615 1.09069V2.86733H14.0229C14.5604 2.86733 15 3.30694 15 3.84419C15 4.33639 14.6314 4.74627 14.1567 4.81195V15.5443C14.1567 16.1994 13.8891 16.7946 13.4581 17.2258C13.027 17.657 12.4318 17.9246 11.7767 17.9246H3.22351C2.56842 17.9246 1.97325 17.657 1.54207 17.2258C1.1109 16.7946 0.84327 16.1994 0.84327 15.5443V4.81195C0.368598 4.74627 0 4.33639 0 3.84419C0 3.30694 0.439832 2.86733 0.977084 2.86733ZM10.6006 6.26815C11.075 6.26815 11.4631 6.65627 11.4631 7.13095V14.5096C11.4631 14.984 11.075 15.3721 10.6006 15.3721C10.1261 15.3721 9.73799 14.984 9.73799 14.5096V7.13095C9.73799 6.65627 10.1261 6.26815 10.6006 6.26815ZM7.5 6.26815C7.97445 6.26815 8.36258 6.65627 8.36258 7.13095V14.5096C8.36258 14.984 7.97445 15.3721 7.5 15.3721C7.02555 15.3721 6.63742 14.984 6.63742 14.5096V7.13095C6.63742 6.65627 7.02555 6.26815 7.5 6.26815ZM4.39943 6.26815C4.87388 6.26815 5.26201 6.65627 5.26201 7.13095V14.5096C5.26201 14.984 4.87388 15.3721 4.39943 15.3721C3.92498 15.3721 3.53685 14.984 3.53685 14.5096V7.13095C3.53685 6.65627 3.92498 6.26815 4.39943 6.26815ZM13.0514 4.82128H1.94884V15.5443C1.94884 15.8943 2.09242 16.213 2.32365 16.4442C2.55489 16.6754 2.87355 16.819 3.22351 16.819H11.7767C12.1264 16.819 12.4451 16.6754 12.6763 16.4442C12.9076 16.213 13.0514 15.8943 13.0514 15.5443V4.82128ZM5.72358 2.86733H9.27664V1.47127H5.72358V2.86733Z"
              fill="#EC4950"></path>
    </svg>
);

// Kupon numarası kopyalama. `COPY_ICON` bağlantısız duran bir SVG'ydi: simge görünüyor ama
// tıklamak hiçbir şey yapmıyordu. Kopyalama + "Kopyalandı" bildirimi zaten `copyMemberNumber`da.
function CopyTicketNo({ticket}: { ticket: any }) {
    // Onaylanmamış bilette numara yerine "Oynanıyor" yazıyor - kopyalanacak bir şey yok.
    if (!ticket?.approve_code && ticket?.status !== 6) {
        return null;
    }
    return (
        <span className="cursor-pointer" title="Kupon numarasını kopyala"
              onClick={(e) => {
                  e.stopPropagation();
                  copyMemberNumber(String(ticketNumberText(ticket)), "Kupon numarası kopyalandı!");
              }}>
            {COPY_ICON}
        </span>
    );
}

// Masaüstü tablo satırı (+ bekleyen statü uyarısı).
function TicketTableRow({ticket, status, onDetail, onPlay, onCancel, onDelete}: {
    ticket: any; status: any; onDetail: (t: any) => void; onPlay: (t: any) => void; onCancel: (t: any) => void; onDelete: (t: any) => void;
}) {
    const hint = pendingStatusHint(ticket.status);
    return (
        <React.Fragment>
            <tr>
                <td>
                    <div className="d-flex">
                        <p className="text-xsmall ticket-id">{ticketNumberText(ticket)}</p>
                        <CopyTicketNo ticket={ticket}/>
                    </div>
                    <p className="text-xsmall">{dateTimeFormat(ticket.approve_date ?? ticket.create_date).replace(' ', ' , ')}</p>
                </td>
                {status !== 6 && <td>
                    <div className="d-flex align-items-center">
                        <p className="text-xsmall text-bold me-1" style={{color: statusMap[ticket.status].class}}>{statusMap[ticket.status].label}</p>
                        <span dangerouslySetInnerHTML={{__html: statusMap[ticket.status].icon}}></span>
                    </div>
                </td>}
                <td className="ticket-bet-type">
                    <p className="text-xsmall text-bold">{ticketBetTypeName(ticket)}</p>
                </td>
                <td className="">
                    <p className="text-xsmall text-bold">{ticketHippodromeLabel(ticket)}</p>
                </td>
                <td>
                    {/* Sütun sabit olduğu için satır gizlenemiyor; birden fazla koşuya yayılmış
                        kombinede yanıltıcı sayı yerine "-" yazılıyor. */}
                    <p className="text-xsmall">{isTicketLongterm(ticket) ? '-' : (ticketSingleRaceNo(ticket) ?? '-')}</p>
                </td>
                <td>
                    <p className="text-xsmall text-bold">{ticket.multiply}</p>
                </td>
                <td>
                    <p className="text-xsmall text-bold" style={{color: "rgb(53, 53, 53)"}}>
                        <TicketAmountCell ticket={ticket} status={status}/>
                    </p>
                </td>
                <td className="ticket-detail-button" onClick={() => onDetail(ticket)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
                        <path d="M1 11L5 6L1 1" stroke="#1F3735" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                </td>
                {status === 6 && <td style={{width: "147px"}}>
                    <div className="ticket-play-or-delete">
                        <button onClick={() => onPlay(ticket)} className="button xs tertiary outlined play-saved-ticket ">
                            <span className="text-xsmall text-primary fw-medium d-flex justify-content-center align-items-center">Hemen Oyna</span>
                        </button>
                        <div onClick={() => onDelete(ticket)} className="delete-saved-ticket d-flex justify-content-center align-items-center">
                            {TRASH_ICON}
                        </div>
                    </div>
                </td>}
                {isTicketReplayable(ticket) &&
                    <td className="">
                        <div className="d-flex justify-content-center">
                            <button onClick={() => onPlay(ticket)} className="button xs tertiary outlined ticket-replay-btn ml-2 ">
                                Tekrar Oyna
                            </button>
                            {!isTicketFob(ticket) &&
                                <button onClick={() => onCancel(ticket)} className="button xs tertiary outlined cancel-coupon-btn ">
                                    İptal Et
                                </button>}
                        </div>
                    </td>
                }
            </tr>

            {hint &&
                <tr>
                    <th colSpan={9} className={"p-0"}>
                        <p className="my-1 alert alert-warning p-2 text-xxsmall fw-bold">{hint}</p>
                    </th>
                </tr>}
        </React.Fragment>
    );
}

// Sayfalama şeridi. Liste tek sayfa yükleniyor; şerit görünüm olarak korunuyor (eski davranış).
function PaginationStrip() {
    const arrow = (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 6H9.5M9.5 6L6 2.5M9.5 6L6 9.5" stroke="#353535" strokeWidth="1.66" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
    );
    return (
        <div className="pagination-wrapper">
            <ul role="navigation" aria-label="Pagination">
                <li className="pagination-prev disable-page">
                    <a className=" " tabIndex={-1} role="button" aria-disabled="true" aria-label="Previous page">
                        <div className="d-flex">{arrow}<p className={"disable-page-button"}> Geri</p></div>
                    </a>
                </li>
                <li className="page selected">
                    <a rel="canonical" role="button" className="selected-page" tabIndex={-1} aria-label="Page 1 is your current page" aria-current="page">1</a>
                </li>
                <li className="page-next disable-page">
                    <a className=" " tabIndex={-1} role="button" aria-disabled="true" aria-label="Next page" rel="next">
                        <div className="d-flex"><p className={"disable-page-button"}> İleri</p>{arrow}</div>
                    </a>
                </li>
            </ul>
        </div>
    );
}

// İşlem sonucu modalları (iptal/silme): sunucu hatasında başlık + açıklama, ağ hatasında kısa süreli uyarı.
function showActionFailure(res: any) {
    let modalTitle = "İşlem başarısız!";
    if (res && res.data && res.data.error && res.data.error.error_description) {
        modalTitle = res.message;
        res.message += `${res.data.error.error_description}`
    }
    modalServiceSubject.next({
        title: modalTitle,
        case: 'danger',
        content: res.message,
        timeout: 10000,
        confirm: {cancel: {label: 'Tamam'}}
    });
}

function showActionError(err: any) {
    console.error(err);
    modalServiceSubject.next({
        title: 'Hata',
        content: err,
        timeout: 3000,
        confirm: {cancel: {label: 'Tamam'}}
    });
}

function TicketList(prop: any) {
    const status = prop.status;
    const [listTickets, setListTickets] = useState<any>(null);
    const [detailTicket, setDetailTicket] = useState<any>(null);
    // Açılan biletlerin çözülmüş koşuları/sonuçları; bir kez çözülen bilet yeniden çözülmüyor.
    const [legData, setLegData] = useState<LegData>(emptyLegData);
    const resolvedTickets = useRef<Set<any>>(new Set());
    // Bülten güncellemesi (kartın koşusu kapandı mı -> "Tekrar Oyna"/"İptal Et") anlık görüntüden.
    useDailyRaces();
    const bulletinCardId = useBulletinCardId();
    const navigate = useNavigate();

    const loadData = (page: number) => {
        let api = new ApiService();
        api.start('post', env.api + '/games/api/tjk/coupons', {status: status, page: page}, true).then((res: any) => {
            if (res.status) {
                const normalizedTickets = normalizeTicketShape(res.data.data);
                setListTickets((prev: any) => (!prev || page === 1) ? normalizedTickets : [...prev, ...normalizedTickets]);
            } else {
                setListTickets(null)
            }
        }).catch(() => {
            setListTickets(null)
        })
    }

    useEffect(() => {
        // status değişince ekranı önce temizliyoruz
        setListTickets(null);
        loadData(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prop, prop.status]);

    const showDetail = (ticket: any) => {
        setDetailTicket(ticket);
        if (resolvedTickets.current.has(ticket.id)) {
            return;
        }
        resolvedTickets.current.add(ticket.id);
        resolveTicketLegData(ticket).then((data) => {
            setLegData((prev) => ({runs: {...prev.runs, ...data.runs}, scores: {...prev.scores, ...data.scores}}));
        });
    }

    const cancelTjkCoupon = (c: any) => {
        try {
            // @ts-ignore
            dataLayer.push({event: "button_click", button_name: "refund_click"});
        } catch (e) {
        }

        modalServiceSubject.next({
            title: 'Kupon İptal',
            case: "info",
            content: `Kuponunuz iptal edilecek, emin misiniz?`,
            confirm: {
                sure: {
                    label: 'Evet',
                    // autoClose açık kalsaydı modal servisi action()'dan SONRA kendi kapanışını
                    // çalıştırıp aşağıda açtığımız bekleme modalını aynı render'da ezerdi.
                    autoClose: false,
                    action: () => {
                        modalServiceSubject.next({
                            case: 'info',
                            title: 'Biletiniz İptal Ediliyor',
                            innerHtml: true,
                            content: `<p class="text-small text-center">İptal talebiniz iletildi. Yanıt gelene kadar lütfen bekleyiniz.</p>`,
                            confirm: null,
                            backdropCloseDisabled: true,
                            cancelBackdrop: true,
                        });

                        let api = new ApiService();
                        api.start('post', env.api + '/games/api/tjk/cancel', {coupon_id: c.id}, true)
                            .then((res: any) => {
                                if (res.status) {
                                    setDetailTicket(null)
                                    // Bilet listeden SİLİNMİYOR; iptal talebi anında sonuçlanmıyor, bilet
                                    // "MBS İptal Bekleniyor" (8) statüsüne geçiyor. Liste tazeleniyor.
                                    loadData(1);
                                    modalServiceSubject.next({
                                        case: 'success',
                                        title: 'İptal Talebiniz Alındı',
                                        innerHtml: true,
                                        content: `<p class="text-small text-center"><b>${c.approve_code || c.id}</b> numaralı biletiniz için iptal talebiniz iletildi. Onaylandığında bilet tutarı hesabınıza iade edilir. Biletin güncel durumunu Kuponlarım listesinden takip edebilirsiniz.</p>`,
                                        confirm: {cancel: {label: 'Tamam'}}
                                    });

                                    try {
                                        // @ts-ignore
                                        dataLayer.push({
                                            event: "refund",
                                            ecommerce: {
                                                transaction_id: c.approve_code,
                                                value: c.amount,
                                                tax: 0,
                                                payment_type: Number(c.point_amount) > 0 ? 'Puan' : 'Bakiye',
                                                currency: "TRY",
                                                items: [
                                                    {
                                                        item_id: `${BettingTypesMap[Number(c.bet_type)]?.name} / ${c.card ? hippodromeNameFor(c.card) : ''} / ${c.race_id} / ${c.date}`,
                                                        item_name: BettingTypesMap[Number(c.bet_type)]?.name,
                                                        item_brand: "",
                                                        item_category: c.card ? hippodromeNameFor(c.card) : '',
                                                        item_category2: c.race_id,
                                                        item_category3: c.card.split('-')[0],
                                                        item_category4: "",
                                                        item_category5: ""
                                                    }
                                                ]
                                            }
                                        });
                                    } catch (e) {
                                    }
                                } else {
                                    showActionFailure(res);
                                }
                            })
                            .catch(showActionError)
                    },
                },
                cancel: {label: 'Hayır'}
            }
        })
    }

    const deleteTjkCoupon = (c: any) => {
        modalServiceSubject.next({
            title: 'Emin misiniz?',
            case: "info",
            content: `${c.approve_code || c.id} numaralı kuponunuzu silmek istediğinizden emin misiniz?`,
            confirm: {
                sure: {
                    label: 'Sil',
                    // Bkz. iptal akışı: autoClose açık kalsaydı bekleme modalı hemen ezilirdi.
                    autoClose: false,
                    action: () => {
                        modalServiceSubject.next({
                            case: 'info',
                            title: 'Kuponunuz Siliniyor',
                            innerHtml: true,
                            content: `<p class="text-small text-center">Silme talebiniz iletildi. Yanıt gelene kadar lütfen bekleyiniz.</p>`,
                            confirm: null,
                            backdropCloseDisabled: true,
                            cancelBackdrop: true,
                        });

                        let api = new ApiService();
                        api.start('post', env.api + '/games/api/tjk/delete-saved', {coupon_id: c.id}, true)
                            .then((res: any) => {
                                if (res.status) {
                                    setListTickets((prev: any) => (prev ?? []).filter((t: any) => t !== c));
                                    modalServiceSubject.next({
                                        case: 'success',
                                        title: 'Kuponunuz Silindi',
                                        innerHtml: true,
                                        content: `<p class="text-small text-center"><b>${c.approve_code || c.id}</b> numaralı kayıtlı kuponunuz silindi.</p>`,
                                        confirm: {cancel: {label: 'Tamam'}}
                                    });
                                } else {
                                    showActionFailure(res);
                                }
                            })
                            .catch(showActionError)
                    },
                },
                cancel: {label: 'Vazgeç'}
            }
        })
    }

    const playTicket = (ticket: any) => {
        try {
            // @ts-ignore
            dataLayer.push({event: "button_click", button_name: "replay_click"});
        } catch (e) {
        }

        if (isTicketFob(ticket)) {
            try {
                replayFobTicketToBetslip(ticket, navigate);
            } catch (error: any) {
                showReplayErrorModal(error?.message ?? 'Kupon yüklenemedi.');
            }
            return;
        }

        const hippodrome = bulletinCardId[Number(ticket.card_id)];
        const betType = hippodrome?.wager_details?.find((w: any) => Number(w.type) === Number(ticket.bet_type));
        if (!hippodrome || !betType || !betType.runs.includes(ticket.race_id)) {
            showClosedTicketModal();
            return;
        }
        try {
            restoreMutualCoupon(hippodrome, ticket);
        } catch (error: any) {
            showReplayErrorModal(error?.message ?? 'Kupon yüklenemedi.');
            return;
        }
        navigate(`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}`);
    }

    const isEmpty = listTickets == null || listTickets.length === 0;
    const detailModal = (
        <TicketDetailModal ticket={detailTicket} legData={legData} onClose={() => setDetailTicket(null)}
                           onCancel={cancelTjkCoupon} onPlay={playTicket}/>
    );

    if (isMobile) {
        return (
            <>
                <div className="container ">
                    <div className={"mb-5 mt-3"}>
                        {listTickets && listTickets.map((ticket: any, keyTicket: number) => (
                            <MobileTicketCard key={`tickets-${keyTicket}`} ticket={ticket} status={status}
                                              onClick={() => showDetail(ticket)} onPlay={playTicket} onDelete={deleteTjkCoupon}/>
                        ))}
                        {isEmpty && <EmptyList mobile={true}/>}
                    </div>
                </div>
                {detailModal}
            </>
        );
    }

    return (
        <>
            <div className="container ">
                <div>
                    {listTickets && listTickets.length > 0 && <table className={"ticket-table mt-2"}>
                        <thead>
                        <tr>
                            <th>Tarih ve Kupon No</th>
                            {status !== 6 && <th>Durum</th>}
                            <th>Bahis Türü</th>
                            <th>Hipodrom</th>
                            <th>Koşu</th>
                            <th>Misli</th>
                            <th>{status === 2 ? 'Kazanç Tutarı' : 'Kupon Tutarı'}</th>
                            <th style={{width: "55px"}}></th>
                            {(status === 6 || status === null) && <th style={{padding: '0'}}></th>}
                        </tr>
                        </thead>
                        <tbody>
                        {listTickets.map((ticket: any, keyTicket: number) => (
                            <TicketTableRow key={`tickets-${keyTicket}`} ticket={ticket} status={status}
                                            onDetail={showDetail} onPlay={playTicket} onCancel={cancelTjkCoupon} onDelete={deleteTjkCoupon}/>
                        ))}
                        </tbody>
                    </table>}
                    {listTickets && listTickets.length > 0 && <PaginationStrip/>}
                    {isEmpty && <EmptyList mobile={false}/>}
                </div>
            </div>
            {detailModal}
        </>
    );
}
